import { render, staticRenderFns } from "./NoticechangeBlock.vue?vue&type=template&id=3adf9ea6&scoped=true"
import script from "./NoticechangeBlock.vue?vue&type=script&lang=js"
export * from "./NoticechangeBlock.vue?vue&type=script&lang=js"
import style0 from "./NoticechangeBlock.vue?vue&type=style&index=0&id=3adf9ea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf9ea6",
  null
  
)

export default component.exports